const formatNumber = number => (number >= 10 ? number : `0${number}`);

export default function formatCount(currentIndex = 0, totalSlides = 0) {
  const currentText = currentIndex + 1;
  const totalText = totalSlides;

  return `${formatNumber(currentText)} / ${formatNumber(totalText)}`;
}
